import ProductMediaMapUtil from 'gw-portals-util-js/ProductMediaMapUtil';

var SECTOR1 = 1711;
var SECTOR2 = 5710;
var SECTOR3 = 8111;
var STOCK_PHOTO_URI = './styles/images/common/stockphotos/';
var occupationImageMap = {
    'sector1': 'sector1',
    'sector2': 'sector2',
    'sector3': 'sector3',
    'default': 'sector4'
};

var questionMap = {
    '01': 'fa-truck',
    '02': 'fa-building',
    '03': 'fa-desktop',
    '04': 'fa-barcode',
    '05': 'fa-money',
    '06': 'fa-users',
    '07': 'fa-hand-paper-o',
    '08': 'fa-plane',
    '09': 'fa-archive',
    '10': 'fa-keyboard-o',
    '11': 'fa-compass',
    '12': 'fa-phone',
    '13': 'fa-archive',
    'default': ''
};

export default {
    getQuestionIcon: function getQuestionIcon(id) {
        return questionMap[id] || questionMap.default;
    },
    getOccupationImage: function getOccupationImage(SIC) {
        var id = _normaliseSIC(SIC);
        var image = occupationImageMap[id] || occupationImageMap.default;
        return '' + STOCK_PHOTO_URI + image + '.svg';
    },
    getProductCodeIcon: function getProductCodeIcon(productCode) {
        return ProductMediaMapUtil.getProductCodeIcon(productCode);
    },
    getProductCodeImage: function getProductCodeImage(productCode) {
        return ProductMediaMapUtil.getProductCodeImage(productCode);
    }
};

function _normaliseSIC(SIC) {
    var normalisedId = 'default';
    var parsedSIC = parseInt(SIC);
    if (!Number.isInteger(parsedSIC)) {
        return normalisedId;
    }
    switch (parsedSIC) {
        case SECTOR1:
            normalisedId = 'sector1';
            break;
        case SECTOR2:
            normalisedId = 'sector2';
            break;
        case SECTOR3:
            normalisedId = 'sector3';
            break;
        default:
            break;
    }
    return normalisedId;
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/util/DynamicContentUtil.js
// module id = 964
// module chunks = 0